var requiredJSLoaded = false;


namespace Pages.Test._Controls.Gantt {

    export function __cdn_pages_test_control_gantt_onDocumentReady() {

        let lightDiv = $("<div style='padding: 20px;'>");        

        $("body").append(lightDiv);        

        let lightGantt = new CDN.Controls.Gantt.Gantt(lightDiv, {
            width: "320px",
            height: "80px",
            error: (lvl, msg, data) => {
                switch (lvl) {
                    case CDN.Common.LogLevel.ERROR:
                        alert(msg);
                        if (data)
                            console.error(data);
                        break;
                    default:
                        console.log(msg);
                        if (data)
                            console.log(data);
                        break;

                }
            },
            xaxis: {
                min: new Date(2022, 1, 1, 8, 0, 0).getTime(),
                max: new Date(2022, 1, 1, 10, 0, 0).getTime(),
                mode: "time",
                timeBase: "milliseconds",
                reserveSpace: false,
                timezone: "browser",
                tickFormatter: (val, axis: jquery.flot.axis) => {
                    let tzDatetime: Date = new Date(val);
                    tzDatetime.addHours(0);
                    if (axis.max - axis.min < 1000 * 5) {
                        return tzDatetime.format("HH:mm:ss.fff")
                    }
                    else if (axis.max - axis.min < 1000 * 300) {
                        return tzDatetime.format("HH:mm:ss")
                    }
                    else if (axis.max - axis.min < 1000 * 60 * 60) {
                        return tzDatetime.format("HH:mm")
                    }
                    else {
                        return tzDatetime.format("HH:mm")
                    }
                },
            },
            series: {
                [0]: new CDN.Controls.Gantt.GanttSeries({
                    from: 0.0,
                    to: 1.0,
                }),
                [1]: new CDN.Controls.Gantt.GanttSeries({
                    from: 0.0,
                    to: 0.5,
                }),
                [2]: new CDN.Controls.Gantt.GanttSeries({
                    from: 0.5,
                    to: 1.0,
                }),
            }
        });

        //Basic Test (green)
        lightGantt.series(0).addMarking({
            from: new Date(2022, 1, 1, 8, 0, 0).getTime(),
            to: new Date(2022, 1, 1, 9, 0, 0).getTime(),
        }, 'rgb(0,255,0)', 1);

        //Test Second Series with different y range (red)
        lightGantt.series(1).addMarking({
            from: new Date(2022, 1, 1, 9, 40, 0).getTime(),
            to: new Date(2022, 1, 1, 9, 50, 0).getTime(),
        }, 'rgb(255,0,0)', 1);

        //Test third series with overlapping markings (yellow and blue)
        lightGantt.series(2).addMarking({
            from: new Date(2022, 1, 1, 9, 45, 0).getTime(),
            to: new Date(2022, 1, 1, 10, 0, 0).getTime(),
        }, 'rgb(0,0,255)', 1); //Prioritize blue
        lightGantt.series(2).addMarking({
            from: new Date(2022, 1, 1, 9, 35, 0).getTime(),
            to: new Date(2022, 1, 1, 10, 0, 0).getTime(),
        }, 'rgb(255,255,0)', 0);

        lightGantt.show();
        lightGantt.draw();
    };
}

CDN.requireOnce([
    { code: CDN.PackageCode.JQuery, },
    { code: CDN.PackageCode.Common, },
    { code: CDN.PackageCode.Control_Gantt, },
], () => {
    requiredJSLoaded = true;
    $(document).ready(Pages.Test._Controls.Gantt.__cdn_pages_test_control_gantt_onDocumentReady);
});